import { cognitoLogOut, cognitoRefresh } from "./cognito";
import { tipoSistema } from "../constants/Tipos";
import { localStorageData } from "../../common/constants/Settings";

export const getSession = async () => {
    let user = getTokens();

    if (user) {
        if (new Date(user.token_expires_at) < new Date()) {
            let response = await cognitoRefresh(
                user.refresh_token,
                user.token,
                tipoSistema.ConsolaSoporte
            );

            user.token = response.AuthenticationResult?.AccessToken;

            const token_expires_at = new Date();
			token_expires_at.setSeconds(token_expires_at.getSeconds() +  response.AuthenticationResult.ExpiresIn);

            user.token_expires_at = token_expires_at;

            localStorage.setItem(localStorageData.USER, JSON.stringify(user));
        }

        return {
            AccessToken: user.token
        };
    }

    return {};
};

//Manages logout when session couldnt be retrieved
export const getSessionHandler = async () => {
    try {
        const sesion = await getSession();
        if (!sesion) {
            await logout();
        }

        return sesion;
    } catch (error) {
        await logout();
        return null;
    }
};

export const logout = async () => {
    try {
        let tokens = getTokens();
        if (tokens) {
            await cognitoLogOut(tokens.AccessToken);
        }
    } catch (error) {
        console.error(error);
    } finally {
        localStorage.clear();
    }
};

const getTokens = () => {
    let authTokens = localStorage.getItem(localStorageData.USER);

    if (authTokens) {
        let resp = JSON.parse(authTokens);
		return resp;
    }

    return null;
};

export const refreshService = async (tokens) => {
    try {
        let response = await cognitoRefresh(
            tokens.RefreshToken,
            tokens.AccessToken,
            tipoSistema.ConsolaSoporte
        );

        return response;
    } catch (error) {
        return null;
    }
};